import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface PlotListProps {
  items: Article[];
}

export default function PlotList({ items }: PlotListProps) {
  return (
    <div className="rounded-lg bg-background-50 border border-background-200 divide-y divide-background-200 max-h-[440px] overflow-y-auto cards-scroll">
      {items.map((article, index) => (
        <Link
          key={article.id}
          to={`/detail/${article.movieId}`}
          className="group flex items-start gap-4 p-4 hover:bg-background-100 transition-colors cursor-pointer"
        >
          <span className="shrink-0 w-7 h-7 rounded-md bg-secondary-100 text-secondary-800 font-label text-sm font-semibold flex items-center justify-center">
            {index + 1}
          </span>
          <div className="flex-1 min-w-0">
            <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
              {article.title}
            </h3>
            <p className="mt-1 text-xs md:text-sm font-label text-foreground-600 line-clamp-2">{article.summary}</p>
            <div className="mt-2 flex flex-wrap items-center gap-3 text-xs font-label text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-movie-2-line w-3.5 h-3.5 flex items-center justify-center"></i>
                {article.movieTitle}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-price-tag-3-line w-3.5 h-3.5 flex items-center justify-center"></i>
                {article.category}
              </span>
              <span>{article.date}</span>
            </div>
          </div>
          <i className="ri-arrow-right-s-line text-foreground-300 group-hover:text-primary-500 transition-colors shrink-0 w-5 h-5 flex items-center justify-center"></i>
        </Link>
      ))}
    </div>
  );
}